"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityCrudWithReordering = exports.ReorderingView = void 0;
exports.EntityWrapperWithReordering = EntityWrapperWithReordering;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@dnd-kit/core");
var sortable_1 = require("@dnd-kit/sortable");
var utilities_1 = require("@dnd-kit/utilities");
var modifiers_1 = require("@dnd-kit/modifiers");
var lucide_react_1 = require("lucide-react");
var button_1 = require("@/components/ui/button");
var input_1 = require("@/components/ui/input");
var use_toast_1 = require("@/hooks/use-toast");
var EntityProvider_1 = __importDefault(require("@/container/pages/entities/common/EntityProvider"));
var useEntityCRUD_1 = require("@/container/pages/entities/common/hooks/useEntityCRUD");
var EntityWrapper_1 = require("@/container/pages/entities/common/EntityWrapper");
var react_query_1 = require("@tanstack/react-query");
var api_1 = __importDefault(require("../../../../../services/api"));
var SortableItem = react_1.default.memo(function (_a) {
    var item = _a.item, index = _a.index, config = _a.config, isActive = _a.isActive, _b = _a.isDragOverlay, isDragOverlay = _b === void 0 ? false : _b, onQuickMove = _a.onQuickMove, searchTerm = _a.searchTerm, globalIndex = _a.globalIndex;
    var _c = (0, sortable_1.useSortable)({
        id: item.id,
        data: { index: globalIndex },
    }), attributes = _c.attributes, listeners = _c.listeners, setNodeRef = _c.setNodeRef, transform = _c.transform, transition = _c.transition, isDragging = _c.isDragging;
    var style = {
        transform: utilities_1.CSS.Transform.toString(transform),
        transition: transition,
        opacity: isDragging ? 0.5 : 1,
    };
    var highlightText = (0, react_1.useCallback)(function (text, search) {
        if (!search || !text)
            return text;
        var parts = String(text).split(new RegExp("(".concat(search, ")"), 'gi'));
        return parts.map(function (part, i) {
            return part.toLowerCase() === search.toLowerCase() ? ((0, jsx_runtime_1.jsx)("mark", { className: "bg-yellow-100 dark:bg-yellow-900/30 px-1 rounded", children: part }, i)) : (part);
        });
    }, []);
    var primaryText = item[config.displayFields.primary] || 'Unnamed';
    var secondaryText = config.displayFields.secondary
        ? item[config.displayFields.secondary]
        : null;
    var tertiaryText = config.displayFields.tertiary
        ? item[config.displayFields.tertiary]
        : null;
    var handleQuickMove = (0, react_1.useCallback)(function (e, position) {
        e.stopPropagation();
        onQuickMove(item.id, position);
    }, [item.id, onQuickMove]);
    return ((0, jsx_runtime_1.jsx)("div", { ref: setNodeRef, style: style, className: "\n        group relative bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 \n        rounded-md hover:border-gray-300 dark:hover:border-gray-600 transition-colors\n        ".concat(isActive ? 'ring-1 ring-blue-500 border-blue-500' : '', "\n        ").concat(isDragOverlay ? 'shadow-lg' : 'shadow-sm', "\n        mb-2\n      "), children: (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center p-3 gap-3", children: [(0, jsx_runtime_1.jsx)("div", __assign({}, attributes, listeners, { className: "cursor-grab active:cursor-grabbing p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 touch-none", children: (0, jsx_runtime_1.jsx)(lucide_react_1.GripVertical, { size: 16 }) })), (0, jsx_runtime_1.jsx)("div", { className: "flex-shrink-0 w-8 h-8 bg-gray-100 dark:bg-gray-700 rounded text-xs font-medium flex items-center justify-center text-gray-600 dark:text-gray-300", children: globalIndex + 1 }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-1 min-w-0", children: [(0, jsx_runtime_1.jsx)("div", { className: "font-medium text-gray-900 dark:text-gray-100 text-sm truncate", children: highlightText(primaryText, searchTerm) }), secondaryText && ((0, jsx_runtime_1.jsx)("div", { className: "text-xs text-gray-500 dark:text-gray-400 truncate mt-0.5", children: highlightText(secondaryText, searchTerm) })), tertiaryText && ((0, jsx_runtime_1.jsx)("div", { className: "text-xs text-gray-400 dark:text-gray-500 truncate", children: highlightText(tertiaryText, searchTerm) }))] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex opacity-0 group-hover:opacity-100 transition-opacity", children: [(0, jsx_runtime_1.jsx)("button", { onClick: function (e) { return handleQuickMove(e, 0); }, className: "p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300", title: "Move to top", children: (0, jsx_runtime_1.jsx)(lucide_react_1.ArrowUp, { size: 14 }) }), (0, jsx_runtime_1.jsx)("button", { onClick: function (e) { return handleQuickMove(e, -1); }, className: "p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300", title: "Move to bottom", children: (0, jsx_runtime_1.jsx)(lucide_react_1.ArrowDown, { size: 14 }) })] }), config.priorityField && ((0, jsx_runtime_1.jsx)("div", { className: "text-xs text-gray-400 dark:text-gray-500 font-mono", children: item[config.priorityField] }))] }) }));
}, function (prevProps, nextProps) {
    return (prevProps.item.id === nextProps.item.id &&
        prevProps.globalIndex === nextProps.globalIndex &&
        prevProps.isActive === nextProps.isActive &&
        prevProps.searchTerm === nextProps.searchTerm &&
        prevProps.isDragOverlay === nextProps.isDragOverlay);
});
SortableItem.displayName = 'SortableItem';
var VirtualListWithDnd = react_1.default.memo(function (_a) {
    var items = _a.items, config = _a.config, activeId = _a.activeId, onQuickMove = _a.onQuickMove, searchTerm = _a.searchTerm, _b = _a.itemHeight, itemHeight = _b === void 0 ? 74 : _b, _c = _a.overscan, overscan = _c === void 0 ? 10 : _c;
    var _d = (0, react_1.useState)({ start: 0, end: 100 }), visibleRange = _d[0], setVisibleRange = _d[1];
    var scrollRef = (0, react_1.useRef)(null);
    var lastScrollTop = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(function () {
        var container = scrollRef.current;
        if (!container)
            return;
        var handleScroll = function () {
            var scrollTop = container.scrollTop;
            var containerHeight = container.clientHeight;
            // Only update if scrolled enough
            if (Math.abs(scrollTop - lastScrollTop.current) < itemHeight / 2) {
                return;
            }
            lastScrollTop.current = scrollTop;
            var start = Math.max(0, Math.floor(scrollTop / itemHeight) - overscan);
            var end = Math.min(items.length, Math.ceil((scrollTop + containerHeight) / itemHeight) + overscan);
            setVisibleRange({ start: start, end: end });
        };
        handleScroll();
        container.addEventListener('scroll', handleScroll, { passive: true });
        return function () { return container.removeEventListener('scroll', handleScroll); };
    }, [items.length, itemHeight, overscan]);
    var visibleItems = items.slice(visibleRange.start, visibleRange.end);
    var totalHeight = items.length * itemHeight;
    var offsetY = visibleRange.start * itemHeight;
    // Only make visible items sortable
    var visibleIds = visibleItems.map(function (item) { return item.id; });
    return ((0, jsx_runtime_1.jsx)("div", { ref: scrollRef, className: "flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600", style: { overscrollBehavior: 'contain' }, children: (0, jsx_runtime_1.jsx)("div", { style: { height: totalHeight, position: 'relative' }, children: (0, jsx_runtime_1.jsx)(sortable_1.SortableContext, { items: visibleIds, strategy: sortable_1.verticalListSortingStrategy, children: (0, jsx_runtime_1.jsx)("div", { style: {
                        transform: "translateY(".concat(offsetY, "px)"),
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        paddingRight: '1rem',
                        paddingLeft: '1rem',
                    }, children: visibleItems.map(function (item, idx) {
                        var globalIndex = visibleRange.start + idx;
                        return ((0, jsx_runtime_1.jsx)(SortableItem, { item: item, index: idx, globalIndex: globalIndex, config: config, isActive: activeId === item.id, onQuickMove: onQuickMove, searchTerm: searchTerm }, item.id));
                    }) }) }) }) }));
});
VirtualListWithDnd.displayName = 'VirtualListWithDnd';
// Main Reordering View
var ReorderingView = function (_a) {
    var items = _a.items, config = _a.config, entityName = _a.entityName, onReorder = _a.onReorder, onBack = _a.onBack, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _c = (0, react_1.useState)(null), activeId = _c[0], setActiveId = _c[1];
    var _d = (0, react_1.useState)(''), searchTerm = _d[0], setSearchTerm = _d[1];
    var _e = (0, react_1.useState)(items), localItems = _e[0], setLocalItems = _e[1];
    var _f = (0, react_1.useState)(false), hasChanges = _f[0], setHasChanges = _f[1];
    var _g = (0, react_1.useState)(false), isSaving = _g[0], setIsSaving = _g[1];
    // Lighter sensors for better performance
    var sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.PointerSensor, {
        activationConstraint: {
            distance: 5,
        },
    }), (0, core_1.useSensor)(core_1.KeyboardSensor, {
        coordinateGetter: sortable_1.sortableKeyboardCoordinates,
    }));
    (0, react_1.useEffect)(function () {
        setLocalItems(items);
        setHasChanges(false);
    }, [items]);
    // Debounced search
    var _h = (0, react_1.useState)(''), debouncedSearchTerm = _h[0], setDebouncedSearchTerm = _h[1];
    (0, react_1.useEffect)(function () {
        var timer = setTimeout(function () {
            setDebouncedSearchTerm(searchTerm);
        }, 300);
        return function () { return clearTimeout(timer); };
    }, [searchTerm]);
    // Optimized filtering
    var filteredItems = (0, react_1.useMemo)(function () {
        if (!debouncedSearchTerm)
            return localItems;
        var searchLower = debouncedSearchTerm.toLowerCase();
        return localItems.filter(function (item) {
            return config.searchFields.some(function (field) {
                var value = item[field];
                return value && String(value).toLowerCase().includes(searchLower);
            });
        });
    }, [localItems, debouncedSearchTerm, config.searchFields]);
    var handleDragStart = (0, react_1.useCallback)(function (event) {
        setActiveId(event.active.id);
    }, []);
    var handleDragEnd = (0, react_1.useCallback)(function (event) {
        var active = event.active, over = event.over;
        setActiveId(null);
        if (active.id !== (over === null || over === void 0 ? void 0 : over.id)) {
            setLocalItems(function (items) {
                var oldIndex = items.findIndex(function (item) { return item.id === active.id; });
                var newIndex = items.findIndex(function (item) { return item.id === (over === null || over === void 0 ? void 0 : over.id); });
                if (oldIndex !== -1 && newIndex !== -1) {
                    var newItems = (0, sortable_1.arrayMove)(items, oldIndex, newIndex);
                    setHasChanges(true);
                    return newItems;
                }
                return items;
            });
        }
    }, []);
    var handleQuickMove = (0, react_1.useCallback)(function (itemId, position) {
        setLocalItems(function (items) {
            var itemIndex = items.findIndex(function (item) { return item.id === itemId; });
            if (itemIndex === -1)
                return items;
            var item = items[itemIndex];
            var newItems = __spreadArray([], items, true);
            newItems.splice(itemIndex, 1);
            if (position === 0) {
                newItems.unshift(item);
            }
            else if (position === -1) {
                newItems.push(item);
            }
            setHasChanges(true);
            return newItems;
        });
    }, []);
    var handleSave = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedItems, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsSaving(true);
                    updatedItems = localItems.map(function (item, index) {
                        var _a;
                        return (__assign({ id: item.id }, (config.priorityField && (_a = {}, _a[config.priorityField] = index + 1, _a))));
                    });
                    return [4 /*yield*/, onReorder(updatedItems)];
                case 1:
                    _a.sent();
                    setHasChanges(false);
                    (0, use_toast_1.toast)({
                        title: t('common|Success'),
                        description: t("common|L'ordre des éléments a été mis à jour avec succès."),
                    });
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    (0, use_toast_1.toast)({
                        variant: 'destructive',
                        title: t('common|Error'),
                        description: t('common|Erreur durant la réorganisation des éléments.'),
                    });
                    return [3 /*break*/, 4];
                case 3:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [localItems, onReorder, config.priorityField, t]);
    var handleReset = (0, react_1.useCallback)(function () {
        setLocalItems(items);
        setHasChanges(false);
    }, [items]);
    var activeItem = activeId
        ? localItems.find(function (item) { return item.id === activeId; })
        : null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col h-full", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex-shrink-0 border-b border-gray-200 dark:border-gray-700 p-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between mb-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-3", children: [(0, jsx_runtime_1.jsx)(button_1.Button, { variant: "ghost", size: "sm", onClick: onBack, children: (0, jsx_runtime_1.jsx)(lucide_react_1.ArrowLeft, { size: 16 }) }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("h2", { className: "text-lg font-semibold text-gray-900 dark:text-gray-100", children: ["R\u00E9organiser ", t("entities|".concat(entityName))] }), (0, jsx_runtime_1.jsxs)("p", { className: "text-sm text-gray-500 dark:text-gray-400", children: [filteredItems.length, " \u00E9l\u00E9ments", debouncedSearchTerm && " (".concat(localItems.length, " total)")] })] })] }), (0, jsx_runtime_1.jsx)("div", { className: "flex items-center gap-2", children: hasChanges && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(button_1.Button, { variant: "outline", size: "sm", onClick: handleReset, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.RotateCcw, { size: 14, className: "mr-1" }), t('common|Réinitialiser')] }), (0, jsx_runtime_1.jsx)(button_1.Button, { size: "sm", onClick: handleSave, disabled: isSaving, children: isSaving ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Loader2, { size: 14, className: "mr-1 animate-spin" }), "Enregistrement..."] })) : ("Enregistrer l'ordre") })] })) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "relative", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Search, { className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400", size: 16 }), (0, jsx_runtime_1.jsx)(input_1.Input, { placeholder: "Rechercher...", value: searchTerm, onChange: function (e) { return setSearchTerm(e.target.value); }, className: "pl-9" })] })] }), (0, jsx_runtime_1.jsxs)(core_1.DndContext, { sensors: sensors, collisionDetection: core_1.closestCenter, onDragStart: handleDragStart, onDragEnd: handleDragEnd, modifiers: [modifiers_1.restrictToVerticalAxis], measuring: {
                    droppable: {
                        strategy: core_1.MeasuringStrategy.WhileDragging,
                    },
                }, children: [filteredItems.length > 0 ? ((0, jsx_runtime_1.jsx)(VirtualListWithDnd, { items: filteredItems, config: config, activeId: activeId, onQuickMove: handleQuickMove, searchTerm: debouncedSearchTerm })) : ((0, jsx_runtime_1.jsx)("div", { className: "flex-1 flex items-center justify-center", children: (0, jsx_runtime_1.jsx)("div", { className: "text-center py-12 text-gray-500 dark:text-gray-400", children: searchTerm
                                ? 'Aucun élément ne correspond à votre recherche'
                                : 'Aucun élément à afficher' }) })), (0, jsx_runtime_1.jsx)(core_1.DragOverlay, { children: activeItem && ((0, jsx_runtime_1.jsx)("div", { style: { width: '90%', maxWidth: '600px' }, children: (0, jsx_runtime_1.jsx)(SortableItem, { item: activeItem, index: 0, globalIndex: localItems.findIndex(function (item) { return item.id === activeId; }), config: config, isActive: true, isDragOverlay: true, onQuickMove: handleQuickMove, searchTerm: debouncedSearchTerm }) })) })] }), hasChanges && ((0, jsx_runtime_1.jsx)("div", { className: "flex-shrink-0 bg-amber-50 dark:bg-amber-900/20 border-t border-amber-200 dark:border-amber-800 p-3", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between text-sm", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-amber-800 dark:text-amber-200", children: t('common|Vous avez des modifications non enregistrées.') }), (0, jsx_runtime_1.jsxs)("div", { className: "flex gap-2", children: [(0, jsx_runtime_1.jsx)(button_1.Button, { variant: "ghost", size: "sm", onClick: handleReset, children: t('common|Annuler') }), (0, jsx_runtime_1.jsx)(button_1.Button, { size: "sm", onClick: handleSave, disabled: isSaving, children: t('common|Enregistrer') })] })] }) }))] }));
};
exports.ReorderingView = ReorderingView;
// Wrapper component with separate data fetching
var EntityCrudWithReordering = function (_a) {
    var endpoint = _a.endpoint, entityName = _a.entityName, columns = _a.columns, formComponent = _a.formComponent, prepareFormData = _a.prepareFormData, preparePostData = _a.preparePostData, defaultPageSize = _a.defaultPageSize, reorderConfig = _a.reorderConfig, onReorderItems = _a.onReorderItems, entityCrudProps = __rest(_a, ["endpoint", "entityName", "columns", "formComponent", "prepareFormData", "preparePostData", "defaultPageSize", "reorderConfig", "onReorderItems"]);
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(false), isReorderMode = _b[0], setIsReorderMode = _b[1];
    var _c = (0, react_1.useState)(false), isReorderLoading = _c[0], setIsReorderLoading = _c[1];
    // Regular paginated query for normal view
    var listQuery = (0, useEntityCRUD_1.useEntityCRUD)({
        endpoint: endpoint,
        entityName: entityName,
        defaultPageSize: defaultPageSize,
        extraParams: isReorderMode ? undefined : {},
    }).listQuery;
    // Separate query for all items when in reorder mode
    var allItemsQuery = (0, react_query_1.useQuery)({
        queryKey: [entityName, 'all-items'],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.default.get("".concat(endpoint, "?all=true"))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, Array.isArray(data) ? data : data.results || []];
                }
            });
        }); },
        enabled: isReorderMode && !!reorderConfig,
        staleTime: 30000, // Cache for 30 seconds
    });
    var handleReorder = function (reorderedItems) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onReorderItems)
                        return [2 /*return*/];
                    setIsReorderLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, onReorderItems(reorderedItems)];
                case 2:
                    _a.sent();
                    // Refresh both queries
                    listQuery.refetch();
                    allItemsQuery.refetch();
                    return [3 /*break*/, 4];
                case 3:
                    setIsReorderLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    if (isReorderMode && reorderConfig) {
        var items = allItemsQuery.data || [];
        if (allItemsQuery.isLoading) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-center h-full", children: (0, jsx_runtime_1.jsx)(lucide_react_1.Loader2, { className: "animate-spin", size: 32 }) }));
        }
        return ((0, jsx_runtime_1.jsx)(ReorderingView, { items: items, config: reorderConfig, entityName: entityName, onReorder: handleReorder, onBack: function () { return setIsReorderMode(false); }, isLoading: isReorderLoading }));
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-4", children: (0, jsx_runtime_1.jsx)(EntityWrapper_1.EntityWrapper, __assign({ endpoint: endpoint, entityName: entityName, columns: columns, formComponent: formComponent, prepareFormData: prepareFormData, preparePostData: preparePostData, showReorder: !!reorderConfig, setIsReorderMode: setIsReorderMode, listQuery: listQuery }, entityCrudProps)) }));
};
exports.EntityCrudWithReordering = EntityCrudWithReordering;
function EntityWrapperWithReordering(_a) {
    var reorderConfig = _a.reorderConfig, onReorderItems = _a.onReorderItems, props = __rest(_a, ["reorderConfig", "onReorderItems"]);
    return ((0, jsx_runtime_1.jsx)(EntityProvider_1.default, { children: (0, jsx_runtime_1.jsx)(EntityCrudWithReordering, __assign({}, props, { reorderConfig: reorderConfig, onReorderItems: onReorderItems })) }));
}
exports.default = EntityWrapperWithReordering;
